export default __webpack_public_path__ + "static/8_33-fde802ce61b903e94dbe5a909b88b68b.png";